<template>
  <div v-loading="courseAllLoading" class="course-all-box">
    <div style="margin-bottom:20px;display: flex;justify-content: space-between;padding-right:64px;">
      <div>
        <el-button class="action-item" type="primary" icon="el-icon-s-tools" style="margin-right:30px;" @click="setLesson()">手动排课</el-button>
        <el-button class="action-item" type="warning" icon="el-icon-setting" style="margin-right:30px;" @click="setPlan()">排课计划</el-button>
      </div>
      <el-button-group>
        <el-button v-if="week == 1" type="primary" @click="changeWeek"><i class="el-icon-arrow-left"></i>上一页</el-button>
        <el-button v-if="week == 0" type="primary" @click="changeWeek">下一页<i class="el-icon-arrow-right"></i></el-button>
      </el-button-group>
    </div>
    <div class="user-defined-table">
      <div class="user-defined-tr">
        <div v-for="(items,index) in dates" :key="index" class="user-defined-td user-defined-th">
          <template v-if="index === 0">
            <div class="header-div">
              <div class="header-col1">时间段</div>
              <div class="header-col2">日期</div>
              <div class="header-line"></div>
            </div>
          </template>
          <template v-else>
            <div>{{ items.week }}</div>
            <div>{{ items.date }}</div>
          </template>
        </div>
      </div>

      <div v-for="(time,tindex) in timeList" v-if="timeList[tindex + 1]" :key="tindex" class="user-defined-tr">

        <div v-for="(items,index) in dates" :key="index" class="user-defined-td">
          <div v-if="index === 0" class="course-all-list">
            {{ time }} ~ {{ timeList[tindex + 1] }}
          </div>
          <div v-else class="course-all-list">
            <!-- <span v-if="scope.row[items.field].site&&scope.row[items.field].site.name" style="color:#1890ff">{{ scope.row[items.field].site.name }}</span> -->
            <span v-if="lessonList[items.date+'_'+time+'_'+timeList[tindex + 1]]&&lessonList[items.date+'_'+time+'_'+timeList[tindex + 1]].site_name" style="color:#1890ff">
              {{ lessonList[items.date+'_'+time+'_'+timeList[tindex + 1]].site_name }}
            </span>
            <el-button type="text" :disabled="getNum2(items.date+'_'+time+'_'+timeList[tindex + 1])==0" @click="bookShowData2(items.date,time,timeList[tindex + 1])">预约：{{ getNum2(items.date+'_'+time+'_'+timeList[tindex + 1]) }}人</el-button>
          </div>

        </div>

      </div>
    </div>
    <!--排课计划-->
    <el-dialog title="排课计划" :visible.sync="dialogDetailsVisible" width="1200px" top="10vh">
      <plan v-if="dialogDetailsVisible" ref="plan" :coach-id="coachId"></plan>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailsVisible = false">取 消</el-button>
        <el-button type="primary" @click="courseArrangement">确 定</el-button>
      </div>
    </el-dialog>
    <!--手动排课-->
    <el-dialog title="手动排课" :visible.sync="dialogLessonVisible" width="1200px" top="10vh" @close="hiddenLesson">
      <LessonSet v-if="dialogLessonVisible" ref="lessonset" :coach-id="coachId"></LessonSet>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogLessonVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 预约列表 -->
    <el-dialog
      title="预约列表"
      :visible.sync="detailShow"
      width="600px"
    >
      <el-alert :title="detailTitle" type="success" :closable="false" style="margin-top:-30px;margin-bottom: 15px;"></el-alert>
      <el-table v-loading="detailLoading" :data="detailData" height="383px">
        <el-table-column width="80" property="avatar" align="center" label="头像">
          <template slot-scope="scope2">
            <el-avatar :size="40" :src="scope2.row.avatar" @error="true">
              <img :src="base_url+'static/image/default_avatar.png'">
            </el-avatar>
          </template>
        </el-table-column>
        <el-table-column property="name" align="center" label="姓名"></el-table-column>
        <el-table-column width="120" property="phone" align="center" label="手机号"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailShow = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/api/lesson/lesson' // 和数据交互相关写在api 方便复用
import site from '@/api/site/site'
import Plan from './plan'
import LessonSet from './lesson'
export default {
  name: 'LessonCourse',
  // 列绑定格式化器
  filters: {
  },
  components: { Plan, LessonSet },
  props: {
    coachId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_API,
      dialogDetailsVisible: false,
      dialogLessonVisible: false,
      api,
      dates: [],
      timeList: [],
      tableData: {},
      detailShow: false,
      detailType: '',
      detailData: [],
      detailLoading: false,
      detailTitle: '',
      lessonList: {},
      bookData: {},

      key2: 0,
      week: 0,
      times: [],
      courseAllLoading: false,
      siteList: [],
      selectloading: false,
      siteId: '',
      bookLoading: false,
      bookShow: ''

    }
  },
  watch: {
    coachId() {
      this.getOneList()
      this.getBookList()
    },
    siteId(val) {
      this.getOneList()
      this.getBookList()
    }
  },
  beforeMount() {
    this.getdates()
  },
  mounted() {
    this.getTimeList()
    this.getOneList()
    this.getBookList()
  },
  methods: {
    hiddenLesson() {
      this.getOneList()
    },
    getNum2(key) {
      if (this.bookData[key]) {
        return this.bookData[key]
      } else {
        return 0
      }
    },
    bookShowData2(date, time, end_time) {
      this.detailType = 'book'
      this.detailData = []
      this.detailLoading = true
      this.detailTitle = date + ' ' + time + ' - ' + end_time
      api.BookList({
        coach_id: this.coachId,
        date: date,
        start_time: time,
        end_time: end_time,
        site_id: this.siteId
      }).then(res => {
        this.detailData = res.data
        this.detailLoading = false
        this.detailShow = true
      })
    },
    // 排课数据
    getOneList() {
      api.oneList({
        coach_id: this.coachId
      }).then(res => {
        this.lessonList = res.data
      })
    },
    // 预约数据
    getBookList() {
      this.bookData = {}
      api.getBookList({
        coach_id: this.coachId
      }).then((res) => {
        this.bookData = res.data
      })
    },
    // 切换日期
    changeWeek() {
      this.week = 1 - this.week
      this.getdates()
    },
    // 获取日期
    getdates() {
      const now = new Date()
      const weekLabels = ['一', '二', '三', '四', '五', '六', '日']
      const dates = [
        {
          field: 'time',
          week: '',
          date: ''
        }
      ]
      for (let i = 1; i <= 7; i++) {
        const date = new Date(now.getTime() + 24 * 60 * 60 * 1000 * (i - 1 + (this.week * 7)))
        let week = date.getDay()
        week = week === 0 ? 7 : week
        let month = date.getMonth() + 1
        month = month < 10 ? '0' + month : month
        let day = date.getDate()
        day = day < 10 ? '0' + day : day
        dates.push({
          field: 'week' + week,
          week: '周' + weekLabels[week - 1],
          date: date.getFullYear() + '-' + month + '-' + day
        })
      }
      this.$nextTick(() => {
        this.dates = dates
        this.key = Math.random()
      })
    },
    // 获取时间段
    getTimeList() {
      this.timeList = []
      api.getBusinessTime().then((res) => {
        const start_time = Number(res.data.business_start_time.split(':')[0])
        const end_time = Number(res.data.business_end_time.split(':')[0])
        for (let i = start_time; i <= end_time; i++) {
          if (i < 10) {
            this.timeList.push('0' + i + ':00')
          } else {
            this.timeList.push(i + ':00')
          }
        }
      })
    },
    getNum(type, key) {
      if (type === 'coach') {
        if (this.tableData['coach'] && this.tableData['coach'][key]) {
          return this.tableData['coach'][key]
        } else {
          return 0
        }
      } else {
        if (this.tableData['book'] && this.tableData['book'][key]) {
          return this.tableData['book'][key]
        } else {
          return 0
        }
      }
    },

    // -------------------------
    getSiteList(val) {
      this.selectloading = true
      site.Query({
        name: val, page: 1, limit: 10, sort: 'order_no', order: 'asc', coach_id: this.coachId
      }).then(res => {
        this.siteList = res.data.items
        this.selectloading = false
      })
    },
    setPlan() {
      this.dialogDetailsVisible = true
    },
    setLesson() {
      this.dialogLessonVisible = true
    },
    bookShowData(time, field, date) {
      this.bookShow = time + '_' + field
      this.bookLoading = true
      api.BookList({
        time: time,
        field: field,
        date: date,
        coach_id: this.coachId
      }).then(res => {
        this.bookData = res.data
        this.bookLoading = false
      })
    },
    getDateOne() {
      this.courseAllLoading = true
      api.DateOne({
        week: this.week,
        coach_id: this.coachId
      }).then(res => {
        this.courseAllLoading = false
        this.tableData = res.data
      }).catch(() => { this.courseAllLoading = false })
    },
    courseArrangement() {
      const response = this.$refs.plan.lessonPlanList
      api.SavePlan({
        coach_id: this.coachId,
        data: response
      }).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.dialogDetailsVisible = false
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex > 0) {
      //   if (row['week' + columnIndex].site && row['week' + columnIndex].site.name && row['week' + columnIndex].book > 0) {
      //     return 'background:#000;color:#fff;'
      //   } else if (row['week' + columnIndex].site && row['week' + columnIndex].site.name) {
      //     return 'background:e0ffff;color:#fff;'
      //   } else if (row['week' + columnIndex].book > 0) {
      //     return 'background:rgb(225, 243, 216);color:white;'
      //   }
      // }
    }
  }
}
</script>
<style>
.user-defined-table{
    width:95%;
    height:684px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #dfe6ec;
    border-top: 1px solid #dfe6ec;
  }
  .user-defined-tr{
    display: flex;
  }
  .user-defined-td{
    width:12.5%;
    padding: 10px;
    color: #606266;
    font-weight: 500;
    font-size: 14px;
    border-right: 1px solid #dfe6ec;
    border-bottom: 1px solid #dfe6ec;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .user-defined-th{
    font-weight: 600;
  }
  .header-div {
    width:100%;
    position: relative;
  }
  .header-col1 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .header-col2 {
    position: absolute;
    right: 0;
    top: 0;
  }
  .header-line {
    padding-left: 0;
    width: 1px;
    height: 140px;
    transform: rotate(-67deg); /*这里需要自己调整，根据线的位置*/
    -webkit-transform-origin: top;
    transform-origin: top;
    background-color: #fff;
    border-left:1px solid #e5e5e5;
  }
/deep/ .column-custom {
	padding: 0px !important;
}

 /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding: 0 !important;
}

.el-table::before{
  height:0 !important;
}

.course-all-box{
  width: 1260px;
  margin:20px auto;
  height:740px;
  /* overflow-y: scroll; */
}
.is-selected {
    color: #1989FA;
  }
  .course-all-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

</style>
